import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import { CommonRequest } from "@/types/http";

async function create(data: any): Promise<CommonRequest<any>> {
  const response = await http.postData("/asesmen-pra-sedasi", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function update(id: number, data: any): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/asesmen-pra-sedasi/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getByRegister(
  registerId: string | number
): Promise<CommonRequest<any[]>> {
  const response = await http
    .getData(`/register/${registerId}/asesmen-pra-sedasi`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function find(id: number): Promise<CommonRequest<any>> {
  const response = await http
    .getData(`/asesmen-pra-sedasi/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function signDokter(id: number, data: any): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/asesmen-pra-sedasi/${id}/sign-dokter`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function signPpja(id: number, data: any): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/asesmen-pra-sedasi/${id}/sign-ppja`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function destroy(id: number): Promise<CommonRequest<undefined>> {
  const response = await http
    .deleteData(`/asesmen-pra-sedasi/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

function print(id: number) {
  window.open(`${http.getAPI()}/asesmen-pra-sedasi/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  signDokter,
  signPpja,
  destroy,
  print
};
